import Vue from 'vue'
import VueI18n from 'vue-i18n'
import languages from '@/constants/languages'
import en from './messages/en.json'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: { en }
})

const loadedLanguages = ['en'] // our default language that is prelaoded

function setI18nLanguage(lang) {
  i18n.locale = lang
  if (typeof document !== 'undefined') {
    document.querySelector('html').setAttribute('lang', lang)
  }
  return lang
}

export function loadLanguageAsync(lang) {
  const transformedLang = lang.toLowerCase()
  // If the same language
  if (i18n.locale === transformedLang) {
    return Promise.resolve(setI18nLanguage(transformedLang))
  }

  // If the language was already loaded
  if (loadedLanguages.includes(transformedLang)) {
    return Promise.resolve(setI18nLanguage(transformedLang))
  }

  // If the language hasn't been loaded yet
  return import(/* webpackChunkName: "lang-[request]" */ `@/i18n/messages/${transformedLang}.json`).then((messages) => {
    i18n.setLocaleMessage(transformedLang, messages.default)
    loadedLanguages.push(transformedLang)
    return setI18nLanguage(transformedLang)
  })
}

export function getBrowserLocale() {
  const languageKeys = Object.keys(languages)
  const browserLocale = navigator.language
  const foundBrowserLocale = languageKeys.includes(browserLocale)
  const foundBrowserLocaleSmall = languageKeys.includes(browserLocale.slice(0, 2))
  if (foundBrowserLocale) {
    return browserLocale
  }
  if (foundBrowserLocaleSmall) {
    return browserLocale.slice(0, 2)
  }
  return 'en'
}

export default i18n
